const HIDE_VISIBILITY_CLASS = 'hide-visibility';

function controlElementVisibility(
  visibilityElement: HTMLElement,
  breakpointElement: HTMLElement,
  className: string
): void {
  const breakpoint = breakpointElement.offsetTop + breakpointElement.getBoundingClientRect().height;
  const scrollTop =
    (window.pageYOffset || document.documentElement.scrollTop) - (document.documentElement.clientTop || 0);
  visibilityElement.classList[scrollTop >= breakpoint ? 'remove' : 'add'](className);
}

function scrollToProductDetailsEvent(): void {
  const stickyScrollCallToActionElement = document.getElementById('stickyScrollCta');
  const productPriceElement = document.getElementById('productOffer');
  if (stickyScrollCallToActionElement && productPriceElement) {
    stickyScrollCallToActionElement.addEventListener('click', () => {
      const productPriceTop = productPriceElement.offsetTop;
      const headerElementHeight = (document.querySelector('header.page-header') as HTMLElement).offsetHeight || 104;
      window.scrollTo({ behavior: 'smooth', top: productPriceTop - headerElementHeight });
    });
  }
}

function initStickyAddToBag(): void {
  const addToBagElement = document.getElementById('addToCartMain');
  const stickyAddToBagElement = document.getElementById('stickyATB');
  const mainHeader = document.querySelector('.page-header') as HTMLElement;
  const headerBottom = mainHeader.offsetHeight;

  if (addToBagElement === null || stickyAddToBagElement === null) {
    return;
  }

  scrollToProductDetailsEvent();

  stickyAddToBagElement.style.top = `${headerBottom}px`;
  window.addEventListener('scroll', () => {
    controlElementVisibility(stickyAddToBagElement, addToBagElement, HIDE_VISIBILITY_CLASS);
  });
}

export default initStickyAddToBag;
